<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.keyword"
        placeholder="关键字搜索(名称)"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.status"
        placeholder="状态"
        style="width: 120px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in CHANAGE_STATUS"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <Category
        :value="listQuery.categoryId"
        @valueFunc="getCategoryValueFunc"
        type="queryCategory"
        :styleRef="{ width: '200px', marginRight: '10px' }"
        class="filter-item"
      />
      <CascadeRegion
        class="filter-item"
        :value="listQuery.cascadeRegion"
        @valueFunc="getQueryValueFunc"
        type="queryCascadeRegion"
        :styleRef="{ width: '300px' }"
      />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
    </div>

    <div style="margin-bottom: 5px">变更数量:{{ total }}</div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="商户名称" align="center" prop="mchName" width="140"></el-table-column>
      <el-table-column
        label="品牌名称"
        align="center"
        prop="brandName"
        width="140"
      ></el-table-column>
      <el-table-column label="名称" align="center" prop="name" width="160"></el-table-column>
      <el-table-column label="logo" align="center" prop="logo" width="140px">
        <template slot-scope="scope">
          <el-image :src="getTableThumbnailImg(scope.row.logo)" fit="cover"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="地址" align="center" prop="address" width="200">
        <template slot-scope="scope">
          {{ scope.row.provinceName }} | {{ scope.row.cityName }}
        </template>
      </el-table-column>
      <el-table-column
        label="主营类目"
        align="center"
        prop="caterotyName"
        width="200"
      ></el-table-column>
      <el-table-column class-name="status-col" label="状态" align="center">
        <template slot-scope="scope">
          {{ getValue(CHANAGE_STATUS, scope.row.status) }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="审核通过时间" align="center" width="200px">
        <template slot-scope="scope">
          <span>{{ formatApiDate(scope.row.checkedTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="ctdate" label="创建时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="100"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="warning"
            size="mini"
            @click="checkExamineVisible(true, scope.row)"
            :disabled="scope.row.status !== 0"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    审核-->
    <el-dialog
      title="审核"
      :visible.sync="examineVisible"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        ref="examineForm"
        :rules="examineRules"
        :model="examineForm"
        label-position="left"
        label-width="150px"
        style="width: 90%; margin-left:50px;"
      >
        <el-form-item label="店铺编号">
          <span>{{ examineObj.shopId }}</span>
        </el-form-item>
        <el-form-item label="商户编号">
          <span>{{ examineObj.mchId }}</span>
        </el-form-item>
        <el-form-item label="商户名称">
          <span>{{ examineObj.mchName }}</span>
        </el-form-item>
        <el-form-item label="品牌名称">
          <span>{{ examineObj.brandName }}</span>
        </el-form-item>
        <el-form-item label="名称">
          <span>{{ examineObj.name }}</span>
        </el-form-item>
        <el-form-item label="地址">
          <span>{{ examineObj.provinceName }} | {{ examineObj.cityName }}</span>
        </el-form-item>
        <el-form-item label="主营类目">
          <span>{{ examineObj.caterotyName }}</span>
        </el-form-item>
        <el-form-item label="品牌logo ">
          <el-image
            style="width: 100px; height: 100px"
            :src="examineObj.logo"
            fit="cover"
          ></el-image>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item label="审核结果" prop="status">
          <el-select
            v-model="examineForm.status"
            placeholder="状态"
            style="width: 100%"
            class="filter-item"
            clearable
          >
            <el-option
              v-for="item in SHOP_EXAMINE_STATUS"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkExamineVisible(false, {})">取消</el-button>
        <el-button type="primary" @click="examineOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getShopchangeList, checkShopChange } from "@/api/store";
import { formatApiDate, getTableThumbnailImg } from "@/utils/utils";
import {
  DIALOG_TITLE_TYPE,
  getValue,
  CHANAGE_STATUS,
  SHOP_EXAMINE_STATUS
} from "@/utils/enumUtile";
import CascadeRegion from "@/views/components/cascadeRegion.vue";
import Category from "@/views/components/category.vue";

export default {
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    CHANAGE_STATUS() {
      return CHANAGE_STATUS;
    },
    DIALOG_TITLE_TYPE() {
      return DIALOG_TITLE_TYPE;
    },
    SHOP_EXAMINE_STATUS() {
      return SHOP_EXAMINE_STATUS;
    }
  },
  components: { CascadeRegion, Category },
  filters: {},
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 20,
        keyword: null,
        status: null,
        cascadeRegion: [],
        provinceId: null,
        cityId: null,
        categoryId: null
      },
      examineVisible: false, // 审核的弹框
      examineObj: {}, // 审核的弹框
      examineRules: {
        status: [{ required: true, message: "审核结果不能为空", trigger: "change" }]
      },
      examineForm: {
        id: 0, //
        status: null
      }
    };
  },
  created() {
    this.getList();
  },
  watch: {},
  methods: {
    getValue,
    getTableThumbnailImg,
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    /**
     * 查询列表
     */
    getList() {
      this.listLoading = true;
      const form = this.listQuery;
      const params = {
        ...form
      };
      if (form.categoryId && form.categoryId.length !== 0) {
        params.categoryId = form.categoryId[form.categoryId.length - 1];
      }
      delete params.cascadeRegion;
      getShopchangeList(params)
        .then(response => {
          this.list = response.data.entitys;
          this.total = response.data.totalCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },

    /**
     * 获取省市区街道
     * @param type
     * @param resultArr
     */
    getQueryValueFunc(type, resultArr) {
      if (type === "queryCascadeRegion") {
        this.listQuery.cascadeRegion = resultArr;
        this.listQuery.provinceId = resultArr[0] || "";
        this.listQuery.cityId = resultArr[1] || "";
      }
    },
    /**
     * 获取主营类目
     * @param type
     * @param resultArr
     */
    getCategoryValueFunc(type, resultArr) {
      if (type === "queryCategory") {
        this.listQuery.categoryId = resultArr;
      }
    },

    // 审核 start
    checkExamineVisible(val, obj = {}) {
      this.examineObj = obj;
      if (obj && Object.keys(obj).length !== 0) {
        this.examineForm.id = obj.id;
      }
      this.examineVisible = val;
    },
    examineOk() {
      this.$refs["examineForm"].validate(valid => {
        if (valid) {
          const form = this.examineForm;
          const params = {
            ...form
          };
          this.btnLoading = true;
          checkShopChange(params)
            .then(() => {
              this.getList();
              this.checkExamineVisible(false);
              this.$notify({
                title: "成功",
                message: "审核成功",
                type: "success",
                duration: 2000
              });
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    }
    // 审核 end
  }
};
</script>
<style scoped lang="scss"></style>
